const JackpotHome = () => import(/* webpackChunkName: 'jackpot' */ 'wap/views/jackpot/Home')
const OrderList = () => import(/* webpackChunkName: 'jackpot' */ 'wap/views/jackpot/OrderList')
const OrderDetail = () => import(/* webpackChunkName: 'jackpot' */ 'wap/views/jackpot/OrderDetail')

const routes = [
  {
    path: '/jackpot/bets/:orderId',
    name: 'jackpotOrderDetail',
    component: OrderDetail,
    meta: {
      title: 'Jackpot Bet History | Jackpot | MSport',
      enableTheme: true
    }
  },
  // Jackpot订单列表页
  {
    path: '/jackpot/bets',
    name: 'jackpotOrderList',
    component: OrderList,
    meta: {
      title: 'Jackpot History | Jackpot | MSport',
      enableTheme: true
    }
  },
  // jackpot首页
  {
    path: '/jackpot',
    name: 'jackpotHome',
    component: JackpotHome,
    meta: {
      requiresFirstNavs: true,
      title: 'Jackpot | MSport',
      enableTheme: true
    }
  }
]

export default routes
